import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _intersection from 'lodash/intersection';
import _mapKeys from 'lodash/mapKeys';
import _isEmpty from 'lodash/isEmpty';
import _some from 'lodash/some';
import _castArray from 'lodash/castArray';
import _includes from 'lodash/includes';
var isSubset = function isSubset(primary, secondary) {
  if (!Array.isArray(secondary)) {
    // If single permission is passed a string check if it exists in permissions array
    return _includes(primary, secondary);
  }
  return _intersection(primary, secondary).length === secondary.length; // Check if passed array is a subset of permissions array
};

var validFor = function validFor(permissions, checkList) {
  return isSubset(permissions, checkList);
};
var notValidFor = function notValidFor(permissions, checkList) {
  return !isSubset(permissions, checkList);
};
var validForAny = function validForAny(permissions, checkList) {
  return _some(_castArray(checkList), function (permissionItem) {
    return validFor(permissions, permissionItem);
  });
};
var METHOD_LIST = {
  validFor: validFor,
  notValidFor: notValidFor,
  validForAny: validForAny
};
var validatePermissions = function validatePermissions(permissions, rules) {
  var valid = true;
  _mapKeys(rules, function (checkList, rule) {
    if (_isEmpty(checkList)) {
      // Return true if secondary is empty
      return;
    }
    var method = METHOD_LIST[rule];
    if (!method) {
      valid = false;
    } else if (checkList) {
      valid = valid && method(permissions, checkList);
    }
  });
  return valid;
};
export default _objectSpread(_objectSpread({}, METHOD_LIST), {}, {
  validatePermissions: validatePermissions
});